import { useState } from "react";
import Footer from "../home/footer";
import Header from "../home/header";
import Subscribe from "../home/subscribe";

const DeletionPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    confirm: false,
  });

  const[message,setMessage]=useState("")

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!form.confirm) return;

  try {
    const res = await fetch("https://eatful.in/email/deletion.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: form.name,
        email: form.email,
      }),
    });

    const data = await res.json();

    if (data.success) {
      setMessage({
        text: "✅ Request submitted successfully",
        type: "success",
      });
    } else {
      setMessage({
        text: "❌ Failed to submit",
        type: "error",
      });
    }
  } catch (err) {
    console.error(err);
    setMessage({
      text: "❌ Server error. Try again later.",
      type: "error",
    });
  }

  // ⏱️ Auto hide after 3 sec
  setTimeout(() => {
    setMessage({ text: "", type: "" });
  }, 3000);

  setForm({
    name: "",
    email: "",
    confirm: false,
  });
};

  return (
    <>
      <Header />

      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{
          background: "#0f172a",
          minHeight: "80vh",
        }}
      >
        <div
          className="p-4"
          style={{
            background: "#fff",
            borderRadius: "12px",
            width: "100%",
            maxWidth: "420px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
            Data Deletion Request
          </h2>

          <p
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "#666",
              marginBottom: "20px",
            }}
          >
            Request permanent deletion of your account and data.
          </p>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <input
              type="text"
              placeholder="Your Name"
              value={form.name}
              required
              onChange={(e) =>
                setForm({ ...form, name: e.target.value })
              }
              style={inputStyle}
            />

            {/* Email */}
            <input
              type="email"
              placeholder="Your Email"
              value={form.email}
              required
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
              style={inputStyle}
            />

            {/* Checkbox */}
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                    marginTop: "10px"
                }}
                >
                <input
                    type="checkbox"
                    checked={form.confirm}
                    onChange={(e) =>
                    setForm({ ...form, confirm: e.target.checked })
                    }
                    style={{
                    width: "14px",
                    height: "14px",
                    cursor: "pointer",
                    marginTop: "3px"
                    }}
                />

                <span style={{ fontSize: "13px", color: "#555" }}>
                    I confirm that I want to permanently delete my account and all associated data.
                </span>
                </div>

            {/* Button */}
            <button
              type="submit"
              disabled={!form.confirm}
              style={{
                width: "100%",
                marginTop: "20px",
                padding: "10px",
                border: "none",
                borderRadius: "6px",
                background: form.confirm ? "#dc3545" : "#ccc",
                color: "#fff",
                cursor: form.confirm ? "pointer" : "not-allowed",
                fontWeight: "bold",
              }}
            >
              Submit Request
            </button>

           {message.text && (
              <p
                style={{
                  marginTop: "15px",
                  padding: "10px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "14px",
                  background:
                    message.type === "success" ? "#d4edda" : "#f8d7da",
                  color:
                    message.type === "success" ? "#155724" : "#721c24",
                  border:
                    message.type === "success"
                      ? "1px solid #c3e6cb"
                      : "1px solid #f5c6cb",
                }}
              >
                {message.text}
              </p>
            )}
          </form>
        </div>
      </div>

      <Subscribe />
      <Footer />
    </>
  );
};

// ✅ Reusable input style
const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

export default DeletionPage;